import { Navigate, useLocation } from 'react-router-dom';
import { Alert, Container } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/common/Loader';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loader label="Checking your session..." className="py-5" />;

  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;

  if (roles && !roles.includes(user.role)) {
    return (
      <Container className="py-5">
        <Alert variant="warning" className="text-center">
          <i className="bi bi-lock fs-3 d-block mb-2" />
          This screen is only for {roles.join(' and ')} staff.
        </Alert>
      </Container>
    );
  }

  return children;
}
